import {HttpClient, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ServerEndpoints} from '../../../server.endpoints';
import {WorktimeStatsOverviewDto, WorktimeStatsQuery} from './worktime-stats.models';

/**
 * Loads the company-scoped extended worktime-stats overview from the monolith
 * (`/Company/Employee/WorktimeStats`). Single BASE_URL origin; the AuthInterceptor attaches the context token.
 * Audience is company admins + the external Payroll role (gated server-side and by the route guard).
 */
@Injectable({providedIn: 'root'})
export class WorktimeStatsHttpService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  /**
   * Fetch the overview. Omitted `startDate`/`endDate` let the server default to the current calendar year (in the
   * company time zone); empty filter arrays are dropped so the server treats them as "all". The dates are sent as
   * plain calendar days — the server applies the company time zone, so the browser's offset is irrelevant.
   */
  get(query: WorktimeStatsQuery): Observable<WorktimeStatsOverviewDto> {
    let params = new HttpParams().set('activity', query.activity);
    if (query.startDate) params = params.set('start', query.startDate);
    if (query.endDate) params = params.set('end', query.endDate);
    for (const id of query.employmentRelationshipIds ?? []) {
      params = params.append('employmentRelationshipIds', id);
    }
    for (const id of query.employeeIds ?? []) {
      params = params.append('employeeIds', id);
    }

    return this.http.get<WorktimeStatsOverviewDto>(
      this.baseUrl + ServerEndpoints.Company_Employee_WorktimeStats, {params});
  }
}
